import { ActionReducerMapBuilder, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PulseTemplateModel } from 'api/dto/PulseTemplate.dto';
import { demandPollReducer } from 'reduxStore/project/demandPoll/reducer';
import { projectReducer } from 'reduxStore/project/project/reducer';
import { projectLayoutReducer } from 'reduxStore/project/projectLayout/reducer';
import { projectSettingsReducer } from 'reduxStore/project/projectSettings/reducer';
import { pulseProjectReducer } from 'reduxStore/project/pulseProject/reducer';

import { ProjectState, STORE_NAME } from './initialState';

export const projectSlice = createSlice({
  name: STORE_NAME,
  initialState: ProjectState.INITIAL_DOMAIN,
  reducers: {
    // For each reducers please use createAction
    resetCurrentProject: (state) => {
      state.subProjects = ProjectState.INITIAL_DOMAIN['subProjects'];
      state.currentResource = ProjectState.INITIAL_DOMAIN['currentResource'];
      state.isPulseTemplateFullyLoaded = false;
      state.pulseTemplateRequestId = '';
    },
    setProjectListPagination: (
      state,
      action: PayloadAction<ProjectState.ProjectListPagination>,
    ) => {
      state.listPagination = action.payload;
    },
    renameLifecycleProject: (state, action: PayloadAction<{ projectId: number; name: string }>) => {
      const currentProject = state.currentResource.data;
      if (!PulseTemplateModel.isPulseTemplateModel(currentProject)) {
        return;
      }
      const lifecycleProject = currentProject.pulseLifecycleProjects.find(
        (project) => project.id === action.payload.projectId,
      );
      if (lifecycleProject) {
        lifecycleProject.name = action.payload.name;
      }
    },
  },
  extraReducers: (builder: ActionReducerMapBuilder<ProjectState.Domain>) => {
    demandPollReducer(builder);
    projectReducer(builder);
    projectLayoutReducer(builder);
    projectSettingsReducer(builder);
    pulseProjectReducer(builder);
  },
});

export const { resetCurrentProject, setProjectListPagination, renameLifecycleProject } =
  projectSlice.actions;
